import colors from '../theme/colors';
import palette from '../theme/palette';

const variants = [
  {
    props: { variant: 'outlined' },
    style: {
      '& .MuiChip-deleteIcon': {
        color: colors.transparentGray['300'],
        '&:hover': {
          color: colors.transparentGray['500'],
        },
      },
    },
  },
  {
    props: { color: 'primary', variant: 'outlined' },
    style: {
      borderColor: palette.primary.main,
    },
  },
  {
    props: { color: 'secondary', variant: 'outlined' },
    style: {
      borderColor: palette.secondary.main,
      '& .MuiChip-label': {
        color: palette.secondary.dark,
      },
    },
  },
  {
    props: { color: 'error', variant: 'outlined' },
    style: {
      borderColor: palette.error.main,
      '& .MuiChip-label': {
        color: palette.error.dark,
      },
    },
  },
  {
    props: { color: 'success', variant: 'filled' },
    style: {
      '& .MuiChip-icon': {
        color: palette.success.contrastText,
      },
      '& .MuiChip-deleteIcon': {
        color: colors.transparentGray['300'],
        '&:hover': {
          color: colors.transparentGray['500'],
        },
      },
    },
  },
  {
    props: { color: 'success', variant: 'outlined' },
    style: {
      borderColor: palette.success.main,
      '& .MuiChip-label': {
        color: palette.success.dark,
      },
    },
  },
  {
    props: { color: 'warning', variant: 'filled' },
    style: {
      '& .MuiChip-icon': {
        color: palette.warning.contrastText,
      },
      '& .MuiChip-deleteIcon': {
        color: colors.transparentGray['300'],
        '&:hover': {
          color: colors.transparentGray['500'],
        },
      },
    },
  },
  {
    props: { color: 'warning', variant: 'outlined' },
    style: {
      borderColor: palette.warning.main,
      '& .MuiChip-label': {
        color: palette.warning.dark,
      },
    },
  },
  {
    props: { color: 'info' },
    style: {
      color: palette.neutral.dark,
      '& .MuiChip-icon': {
        color: palette.text.secondary,
      },
    },
  },
  {
    props: { color: 'info', variant: 'filled' },
    style: {
      backgroundColor: colors.transparentGray['100'],
      '& .MuiChip-deleteIcon': {
        color: colors.transparentGray['300'],
        '&:hover': {
          color: colors.transparentGray['500'],
        },
      },
    },
  },
  {
    props: { color: 'info', variant: 'outlined' },
    style: {
      borderColor: palette.neutral.light,
    },
  },
  {
    props: { color: 'default' },
    style: {
      backgroundColor: palette.common.white,
      color: palette.neutral.dark,
      '& .MuiChip-icon': {
        color: palette.text.secondary,
      },
    },
  },
  {
    props: { color: 'default', variant: 'filled' },
    style: {
      '& .MuiChip-deleteIcon': {
        color: colors.transparentGray['300'],
        '&:hover': {
          color: colors.transparentGray['500'],
        },
      },
    },
  },
  {
    props: { color: 'default', variant: 'outlined' },
    style: {
      borderColor: palette.neutral.light,
    },
  },
];

export default variants;
